import { useState, useCallback, useRef } from 'react';

import { TooltipHover, Tag, BottomSheet, useBreakpoint } from '@hh.ru/magritte-ui';
import { BanOutlinedSize16 } from '@hh.ru/magritte-ui/icon';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';

const TrlKeys = {
    text: 'resume.snippet.tag.banned',
};

const Banned: TranslatedComponent = ({ trls }) => {
    const [isBottomSheetVisible, setBottomSheetVisibility] = useState(false);
    const { isMobile } = useBreakpoint();
    const activatorRef = useRef<HTMLSpanElement>(null);

    const toggleBottomSheet = useCallback(() => {
        isMobile && setBottomSheetVisibility((value) => !value);
    }, [isMobile, setBottomSheetVisibility]);

    return (
        <>
            <span onClick={toggleBottomSheet} data-interactive ref={activatorRef}>
                <Tag style="negative" icon={BanOutlinedSize16}>
                    {trls[TrlKeys.text]}
                </Tag>
            </span>
            <TooltipHover placement="top-center" maxWidth={250} activatorRef={activatorRef}>
                {trls[TrlKeys.text]}
            </TooltipHover>
            <BottomSheet visible={isBottomSheetVisible} onClose={toggleBottomSheet}>
                {trls[TrlKeys.text]}
            </BottomSheet>
        </>
    );
};

export default translation(Banned);
